import type { DownloadCentreMessage } from '@/stores/downloadCentreStore'
import {
	hasCompletedDownloadCentreMessage,
	hasFailedDownloadCentreMessage,
	hasInFlightDownloadCentreMessage,
} from '@/stores/downloadCentreStore'
import { isTrialCustomer } from '@/utils/user/isTrialCustomer'

export type DownloadCentreAnalyticsStatus =
	| 'Complete'
	| 'Empty'
	| 'Failed'
	| 'In Progress'

export const isDownloadCentreEnabled = (
	user: User | null | undefined
): boolean => {
	if (!user) return false
	if (isTrialCustomer(user)) return false

	return true
}

export const getDownloadCentreAnalyticsStatus = (
	messages: DownloadCentreMessage[]
): DownloadCentreAnalyticsStatus => {
	if (hasInFlightDownloadCentreMessage(messages)) {
		return 'In Progress'
	}

	if (hasFailedDownloadCentreMessage(messages)) {
		return 'Failed'
	}

	if (hasCompletedDownloadCentreMessage(messages)) {
		return 'Complete'
	}

	return 'Empty'
}
